import { SortModelItem } from 'ag-grid-community';
import { RowHeights } from '@core/config/row-heights';
import { Classification } from '@portal-shared/app/entities/class.model';
import { Department } from '@portal-shared/app/entities/department.model';
import { StringUtils } from '@portal-shared/app/utils/string.utils';
import { ProjectAssignmentRowDto } from '@services/dtos/rows/project-assignment-row.dto';
import { AssignmentDefinition } from '@services/models/assignment-definition.model';
import { AssignmentRowType } from '@shared/components/grids/rows/assignments/assignment-row-type.enum';
import { AssignmentHelper } from '@shared/helpers/assignment.helper';
import { AssignmentRow } from './assignment-row';

export class ProjectAssignmentRow extends AssignmentRow {
  public override height = RowHeights.planningGrid.rowMedium;
  public override isRowDroppable = false;
  public override styleClasses = [this.type];

  public department?: Department;
  public classification?: Classification;

  public constructor(
    public dto: ProjectAssignmentRowDto,
    public projectId: string,
    public departmentId: string,
    public classId: string // ClassId can be null = ALL
  ) {
    const resource = dto.resource ?? dto.requestedResource ?? dto.fictionalResource;
    const resourceId = resource?.id ?? AssignmentHelper.unassignedDefaultId;

    const type = dto.resource
      ? AssignmentRowType.Assignment
      : dto.requestedResource
        ? AssignmentRowType.RequestedResource
        : AssignmentRowType.UnassignedAssignment;

    super(dto, projectId, departmentId, classId, resourceId, type);

    if (resource?.departmentCode) {
      this.department = new Department(departmentId, resource?.departmentCode, resource?.departmentDescription);
    }

    if (resource?.classCode) {
      this.classification = new Classification(departmentId, resource?.classCode, resource?.classDescription);
    }
  }

  public override compare(rowB: ProjectAssignmentRow) {
    //  Compare by row type priority
    const rowTypePriorityCompare = rowB.rowTypePriority - this.rowTypePriority;
    if (rowTypePriorityCompare !== 0) {
      return rowTypePriorityCompare;
    }

    //Compare by resource name
    const resourceNameA =
      this.dto.resource?.name ?? this.dto.requestedResource?.name ?? this.dto.fictionalResource?.name;
    const resourceNameB =
      rowB.dto.resource?.name ?? rowB.dto.requestedResource?.name ?? rowB.dto.fictionalResource?.name;
    if (!resourceNameA) {
      return -1;
    } else if (!resourceNameB) {
      return 1;
    }

    return StringUtils.compareStrings(resourceNameA, resourceNameB);
  }

  public override toAssignmentDefinition(): AssignmentDefinition {
    return {
      projectId: this.projectId,
      departmentId: this.departmentId,
      classId: this.classId,
      resourceId: this.dto.resource?.id,
      requestedResourceId: this.dto.requestedResource?.id,
      fictionalResourceId: this.dto.fictionalResource?.id
    };
  }

  public static getDefaultSortModel(): SortModelItem[] {
    const resourceItem: SortModelItem = { colId: 'resourceName', sort: 'asc' };
    const requestItem: SortModelItem = { colId: 'requestedResourceName', sort: 'asc' };
    return [resourceItem, requestItem];
  }
}
